module.exports = __webpack_public_path__ + "static/media/mission.2234822f.svg";